import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { IconButton } from '@mui/material';
import moment from 'moment';
import { useEffect, useState } from 'react';
// import './calendar.scss';

function CustomToolbar(props: any) {
  const [viewState, setViewState] = useState('month');
  const [navState, setNavState] = useState('current');

  useEffect(() => {
    getCustomToolbar();
  }, [viewState]);

  const getCustomToolbar = () => {
    // const toolbarDate = props.date;
    const goToDayView = () => {
      props.onView('day');
      setViewState('day');
    };
    const goToWeekView = () => {
      props.onView('week');
      setViewState('week');
    };
    const goToMonthView = () => {
      props.onView('month');
      setViewState('month');
    };
    const goToAgendaView = () => {
      props.onView('agenda');
      setViewState('agenda');
    };
    const goToBack = () => {
      const view = viewState;
      const mDate = props.date;
      let newDate;
      if (view === 'month') {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth() - 1, 1);
      } else if (view === 'week') {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() - 7, 1);
      } else {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() - 1, 1);
      }
      props.onNavigate('prev', newDate);
      setNavState('prev');
    };
    const goToNext = () => {
      const view = viewState;
      const mDate = props.date;
      let newDate;
      if (view === 'month') {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth() + 1, 1);
      } else if (view === 'week') {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() + 7, 1);
      } else {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() + 1, 1);
      }
      props.onNavigate('next', newDate);
      setNavState('next');
    };

    const goToToday = () => {
      const now = new Date();
      props.date.setMonth(now.getMonth());
      props.date.setYear(now.getFullYear());
      props.date.setDate(now.getDate());
      props.onNavigate('current');
      setNavState('current');
    };

    const month = () => {
      const date = moment(props.date);
      const month = date.format('MMMM');
      const year = date.format('YYYY');
      return (
        <span className="rbc-toolbar-label rbc-date">
          <i className="far fa-calendar" /> <span>{`${month} ${year}`}</span>
        </span>
      );
    };

    const week = () => {
      const date = moment(props.date);
      const month = date.format('MMMM');
      const year = date.format('YYYY');
      // const weekStartDay = date.startOf('week').format('DD');
      // const weekEndDay = date.endOf('week').format('DD');

      return (
        <span className="rbc-toolbar-label rbc-date">
          {/* <i className="far fa-calendar"></i> <span>{`${month} ${weekStartDay}-${weekEndDay}`}</span> */}
          <i className="far fa-calendar" /> <span>{`${month} ${year}`}</span>
        </span>
      );
    };

    const day = () => {
      const view = viewState;
      const date = moment(props.date);
      const month = date.format('MMMM');
      const year = date.format('YYYY');
      let day;
      if (view === 'day') {
        day = `${date.format('DD')} ${date.format('dddd')}`;
        if (document.getElementsByClassName('rbc-day-bg rbc-today')) {
          if (document.getElementsByClassName('rbc-day-bg rbc-today')[0]) {
            document.getElementsByClassName('rbc-day-bg rbc-today')[0].innerHTML = day;
          }
        }
        if (document.getElementsByClassName('rbc-day-bg')) {
          if (document.getElementsByClassName('rbc-day-bg')[0]) {
            document.getElementsByClassName('rbc-day-bg')[0].innerHTML = day;
          }
        }
      }
      return <span className="rbc-toolbar-label">{`${month} ${year}`}</span>;
    };

    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group" style={{ cursor: 'pointer' }}>
          <button
            className={navState === 'current' ? 'rbc-button-active' : ''}
            onClick={goToToday}
            style={{ cursor: 'pointer' }}
          >
            Today
          </button>
          <button
            className={navState === 'prev' ? 'rbc-button-active' : ''}
            onClick={goToBack}
            style={{ cursor: 'pointer' }}
          >
            Back
          </button>
          <button
            className={navState === 'next' ? 'rbc-button-active' : ''}
            onClick={goToNext}
            style={{ cursor: 'pointer' }}
          >
            Next
          </button>
        </span>

        <span className="rbc-toolbar-label">
          <IconButton size="small" className="rbcArrowbtn" aria-label="navigate-before" onClick={goToBack}>
            <NavigateBeforeIcon sx={{ fontSize: 30 }} />
          </IconButton>
          {viewState == 'week' ? week() : viewState == 'day' ? day() : month()}
          <IconButton className="rbcArrowbtn" aria-label="navigate-next" onClick={goToNext}>
            <NavigateNextIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </span>

        <span className="rbc-btn-group">
          <button
            className={viewState === 'month' ? 'rbc-button-active' : ''}
            onClick={goToMonthView}
            style={{ cursor: 'pointer' }}
          >
            Month
          </button>
          <button
            className={viewState === 'week' ? 'rbc-button-active' : ''}
            onClick={goToWeekView}
            style={{ cursor: 'pointer' }}
          >
            Week
          </button>
          <button
            className={viewState === 'day' ? 'rbc-button-active' : ''}
            onClick={goToDayView}
            style={{ cursor: 'pointer' }}
          >
            Day
          </button>
          <button
            className={viewState === 'agenda' ? 'rbc-button-active' : ''}
            onClick={goToAgendaView}
            style={{ cursor: 'pointer' }}
          >
            Agenda
          </button>
        </span>
      </div>
    );
  };

  return <>{getCustomToolbar()}</>;
}

export default CustomToolbar;
